import { Size } from './../primitives/size';
import { pathSegmentCollection, getRectanglePath, processPathData } from './../utility/path-util';
// import { overFlow } from './../utility/base-util';
import { createHtmlElement } from './../utility/dom-util';
/**
 * Canvas Renderer
 */
/** @private */
export class CanvasRenderer {
    constructor() {
        /** @private */
        this.imageList = {};
        this.rectWidth = 0;
    }
    /**   @private  */
    static getContext(canvas) {
        return canvas.getContext('2d');
    }
    setStyle(canvas, style) {
        let ctx = CanvasRenderer.getContext(canvas);
        if (style.fill === 'none') {
            style.fill = 'transparent';
        }
        if (style.stroke === 'none') {
            style.stroke = 'transparent';
        }
        ctx.strokeStyle = style.stroke;
        if (style.thickness !== undefined) {
            ctx.lineWidth = style.thickness * (96 / 72);
        }
        else {
            ctx.lineWidth = style.strokeWidth;
        }
        if (style.strokeWidth === 0) {
            ctx.strokeStyle = 'transparent';
        }
        if (style.isSharpEdge) {
            ctx.lineJoin = 'miter';
            ctx.miterLimit = 10;
            ctx.lineCap = 'butt';
        }
        ctx.globalAlpha = style.opacity;
        let dashArray = [];
        if (style.dashArray) {
            dashArray = this.parseDashArray(style.dashArray);
        }
        ctx.setLineDash(dashArray);
        ctx.fillStyle = style.fill;
    }
    setStyleFreetextEJ2(canvas, style) {
        let ctx = CanvasRenderer.getContext(canvas);
        if (style.fill === 'none') {
            style.fill = 'transparent';
        }
        if (style.stroke === 'none') {
            style.stroke = 'transparent';
        }
        ctx.strokeStyle = style.stroke;
        if (style.thickness !== undefined) {
            ctx.lineWidth = style.thickness * (96 / 72);
        }
        else {
            ctx.lineWidth = style.strokeWidth * (96 / 72);
        }
        if (style.strokeWidth === 0) {
            ctx.strokeStyle = 'transparent';
        }
        ctx.lineJoin = 'miter';
        ctx.miterLimit = 10;
        ctx.lineCap = 'butt';
        ctx.globalAlpha = style.opacity;
        let dashArray = [];
        if (style.dashArray) {
            dashArray = this.parseDashArray(style.dashArray);
        }
        ctx.setLineDash(dashArray);
        ctx.fillStyle = style.fill;
    }
    rotateContext(canvas, angle, x, y) {
        let ctx = CanvasRenderer.getContext(canvas);
        ctx.translate(x, y);
        ctx.rotate(angle * Math.PI / 180);
        ctx.translate(-x, -y);
    }
    setFontStyle(canvas, text) {
        let ctx = CanvasRenderer.getContext(canvas);
        let font = '';
        if (text.italic) {
            font += 'italic ';
        }
        if (text.bold) {
            font += 'bold ';
        }
        font += (text.fontSize) + 'px ';
        font += text.fontFamily;
        ctx.font = font;
    }
    /**   @private  */
    parseDashArray(dashArray) {
        let dashes = [];
        let separator = dashArray.indexOf(' ') !== -1 ? ' ' : ',';
        let splittedDashes = dashArray.split(separator);
        for (let i of splittedDashes) {
            dashes.push(Number(i));
        }
        return dashes;
    }
    //Rendering Part
    /**   @private  */
    drawRectangle(canvas, options) {
        if (options.childNodes === undefined) {
            this.rectWidth = options.width;
        }
        if (options.visible === true) {
            if (options.cornerRadius) {
                options.data = getRectanglePath(options.cornerRadius, options.height, options.width);
                this.drawPath(canvas, options);
            }
            else {
                let ctx = CanvasRenderer.getContext(canvas);
                ctx.save();
                ctx.beginPath();
                let cornerRadius = options.cornerRadius;
                let pivotX = options.x + options.width * options.pivotX;
                let pivotY = options.y + options.height * options.pivotY;
                this.rotateContext(canvas, options.angle, pivotX, pivotY);
                this.setStyle(canvas, options);
                if (options.thickness !== undefined && !options.isShapeLabel) {
                    const strokeWidth = ctx.lineWidth || 1;
                    const halfStroke = strokeWidth / 2;
                    const strokeX = options.x + halfStroke;
                    const strokeY = options.y + halfStroke;
                    const strokeW = Math.max(0, options.width - strokeWidth);
                    const strokeH = Math.max(0, options.height - strokeWidth);
                    if (ctx.fillStyle !== 'transparent') {
                        const fillX = options.x + (strokeWidth > 0 ? strokeWidth : 0);
                        const fillY = options.y + (strokeWidth > 0 ? strokeWidth : 0);
                        const fillW = Math.max(0, options.width - (strokeWidth > 0 ? 2 * strokeWidth : 0));
                        const fillH = Math.max(0, options.height - (strokeWidth > 0 ? 2 * strokeWidth : 0));
                        if (fillW > 0 && fillH > 0) {
                            ctx.fillRect(fillX, fillY, fillW, fillH);
                        }
                    }
                    if (ctx.strokeStyle !== 'transparent' && strokeW > 0 && strokeH > 0) {
                        ctx.rect(strokeX, strokeY, strokeW, strokeH);
                        ctx.stroke();
                        ctx.closePath();
                        ctx.restore();
                    }
                }
                else {
                    ctx.rect(options.x, options.y, options.width, options.height);
                    ctx.fillRect(options.x, options.y, options.width, options.height);
                    ctx.fill();
                    ctx.stroke();
                    ctx.closePath();
                    ctx.restore();
                }
            }
        }
    }
    /**   @private  */
    drawRectangleFreetextEJ2(canvas, options) {
        if (options.childNodes === undefined) {
            this.rectWidth = options.width;
        }
        if (options.visible === true) {
            if (options.cornerRadius) {
                options.data = getRectanglePath(options.cornerRadius, options.height, options.width);
                this.drawPath(canvas, options);
            }
            else {
                let ctx = CanvasRenderer.getContext(canvas);
                ctx.save();
                ctx.beginPath();
                let cornerRadius = options.cornerRadius;
                let pivotX = options.x + options.width * options.pivotX;
                let pivotY = options.y + options.height * options.pivotY;
                this.rotateContext(canvas, options.angle, pivotX, pivotY);
                this.setStyleFreetextEJ2(canvas, options);
                ctx.beginPath();
                ctx.rect(options.x, options.y, options.width, options.height);
                ctx.clip();
                const strokeWidth = ctx.lineWidth || 1;
                const halfStroke = strokeWidth / 2;
                const strokeX = options.x + halfStroke;
                const strokeY = options.y + halfStroke;
                const strokeW = Math.max(0, options.width - strokeWidth);
                let strokeH = Math.max(0, options.height - strokeWidth);
                if (strokeH <= 0) {
                    strokeH = 1;
                }
                if (ctx.fillStyle !== 'transparent') {
                    const fillX = options.x + (strokeWidth > 0 ? strokeWidth : 0);
                    const fillY = options.y + (strokeWidth > 0 ? strokeWidth : 0);
                    const fillW = Math.max(0, options.width - (strokeWidth > 0 ? 2 * strokeWidth : 0));
                    const fillH = Math.max(0, options.height - (strokeWidth > 0 ? 2 * strokeWidth : 0));
                    if (fillW > 0 && fillH > 0) {
                        ctx.fillRect(fillX, fillY, fillW, fillH);
                    }
                }
                if (ctx.strokeStyle !== 'transparent' && strokeW > 0 && strokeH > 0) {
                    ctx.beginPath();
                    ctx.rect(strokeX, strokeY, strokeW, strokeH);
                    ctx.stroke();
                    ctx.closePath();
                }
                ctx.restore();
            }
        }
    }
    /**   @private  */
    drawPath(canvas, options) {
        let collection = [];
        collection = processPathData(options.data);
        collection = pathSegmentCollection(collection);
        let ctx = CanvasRenderer.getContext(canvas);
        ctx.save();
        ctx.beginPath();
        let pivotY = options.y + options.height * options.pivotY;
        let pivotX = options.x + options.width * options.pivotX;
        this.rotateContext(canvas, options.angle, pivotX, pivotY);
        this.setStyle(canvas, options);
        ctx.translate(options.x, options.y);
        this.renderPath(canvas, options, collection);
        ctx.fill();
        ctx.translate(-options.x, -options.y);
        ctx.stroke();
        ctx.restore();
    }
    /**   @private  */
    renderPath(canvas, options, collection) {
        if (options.visible === true) {
            let ctx = CanvasRenderer.getContext(canvas);
            let x0;
            let y0;
            let x1;
            let y1;
            let x2;
            let y2;
            let x;
            let y;
            let length;
            let i;
            let newSeg;
            let segs = collection;
            for (x = 0, y = 0, i = 0, length = segs.length; i < length; ++i) {
                let obj = segs[parseInt(i.toString(), 10)];
                let seg = obj;
                let char = seg.command;
                if ('x1' in seg) {
                    x1 = seg.x1;
                }
                if ('x2' in seg) {
                    x2 = seg.x2;
                }
                if ('y1' in seg) {
                    y1 = seg.y1;
                }
                if ('y2' in seg) {
                    y2 = seg.y2;
                }
                if ('x' in seg) {
                    x = seg.x;
                }
                if ('y' in seg) {
                    y = seg.y;
                }
                switch (char) {
                    case 'M':
                        ctx.moveTo(x, y);
                        seg.x = x;
                        seg.y = y;
                        break;
                    case 'L':
                        ctx.lineTo(x, y);
                        seg.x = x;
                        seg.y = y;
                        break;
                    case 'C':
                        ctx.bezierCurveTo(x1, y1, x2, y2, x, y);
                        seg.x = x;
                        seg.y = y;
                        seg.x1 = x1;
                        seg.y1 = y1;
                        seg.x2 = x2;
                        seg.y2 = y2;
                        break;
                    case 'Q':
                        ctx.quadraticCurveTo(x1, y1, x, y);
                        seg.x = x;
                        seg.y = y;
                        seg.x1 = x1;
                        seg.y1 = y1;
                        break;
                    case 'A':
                        let curr = { x: x0, y: y0 };
                        let rx = seg.r1;
                        let ry = seg.r2;
                        let xAxisRotation = seg.angle * (Math.PI / 180.0);
                        let largeArc = seg.largeArc;
                        let sweep = seg.sweep;
                        let cp = { x: x, y };
                        let currp = {
                            x: Math.cos(xAxisRotation) * (curr.x - cp.x) / 2.0 + Math.sin(xAxisRotation) * (curr.y - cp.y) / 2.0,
                            y: -Math.sin(xAxisRotation) * (curr.x - cp.x) / 2.0 + Math.cos(xAxisRotation) * (curr.y - cp.y) / 2.0
                        };
                        let l = Math.pow(currp.x, 2) / Math.pow(rx, 2) + Math.pow(currp.y, 2) / Math.pow(ry, 2);
                        if (l > 1) {
                            rx *= Math.sqrt(l);
                            ry *= Math.sqrt(l);
                        }
                        let k = (Math.pow(ry, 2) * Math.pow(currp.x, 2));
                        let s = (largeArc === sweep ? -1 : 1) * Math.sqrt(((Math.pow(rx, 2) * Math.pow(ry, 2)) - (Math.pow(rx, 2) * Math.pow(currp.y, 2)) - k) /
                            (Math.pow(rx, 2) * Math.pow(currp.y, 2) + Math.pow(ry, 2) * Math.pow(currp.x, 2)));
                        if (isNaN(s)) {
                            s = 0;
                        }
                        let cpp = { x: s * rx * currp.y / ry, y: s * -ry * currp.x / rx };
                        let centp = {
                            x: (curr.x + cp.x) / 2.0 + Math.cos(xAxisRotation) * cpp.x - Math.sin(xAxisRotation) * cpp.y,
                            y: (curr.y + cp.y) / 2.0 + Math.sin(xAxisRotation) * cpp.x + Math.cos(xAxisRotation) * cpp.y
                        };
                        let a1 = this.a([1, 0], [(currp.x - cpp.x) / rx, (currp.y - cpp.y) / ry]);
                        let u = [(currp.x - cpp.x) / rx, (currp.y - cpp.y) / ry];
                        let v = [(-currp.x - cpp.x) / rx, (-currp.y - cpp.y) / ry];
                        let ad = this.a(u, v);
                        if (this.r(u, v) <= -1) {
                            ad = Math.PI;
                        }
                        if (this.r(u, v) >= 1) {
                            ad = 0;
                        }
                        let dir = !sweep ? -1.0 : 1.0;
                        let ah = a1 + dir * (ad / 2.0);
                        let halfWay = {
                            x: centp.x + rx * Math.cos(ah),
                            y: centp.y + ry * Math.sin(ah)
                        };
                        seg.centp = centp;
                        seg.xAxisRotation = xAxisRotation;
                        seg.rx = rx;
                        seg.ry = ry;
                        seg.a1 = a1;
                        seg.ad = ad;
                        seg.sweep = sweep;
                        if (ctx != null) {
                            let ra = rx > ry ? rx : ry;
                            let sx = rx > ry ? 1 : rx / ry;
                            let sy = rx > ry ? ry / rx : 1;
                            ctx.save();
                            ctx.translate(centp.x, centp.y);
                            ctx.rotate(xAxisRotation);
                            ctx.scale(sx, sy);
                            ctx.arc(0, 0, ra, a1, a1 + ad, !sweep);
                            ctx.scale(1 / sx, 1 / sy);
                            ctx.rotate(-xAxisRotation);
                            ctx.translate(-centp.x, -centp.y);
                            ctx.restore();
                        }
                        break;
                    case 'Z':
                    case 'z':
                        ctx.closePath();
                        x = x0;
                        y = y0;
                        break;
                }
                x0 = x;
                y0 = y;
            }
        }
    }
    /**   @private  */
    drawTextFreetextEJ2(canvas, options, isFreeTextAnnotation, rectHeight) {
        if (options.content && options.visible === true) {
            let ctx = CanvasRenderer.getContext(canvas);
            ctx.save();
            this.setStyle(canvas, options);
            this.setFontStyle(canvas, options);
            let ascent = 0;
            let lineHeight = 0;
            if (options.thickness !== undefined) {
                // Used this to get the exact text height for Freetext annotation according to the font size and font family.
                const metrics = ctx.measureText(options.content);
                ascent = metrics.actualBoundingBoxAscent;
                if (ascent == null)
                    ascent = options.fontSize * 0.8;
                let descent = metrics.actualBoundingBoxDescent;
                if (descent == null)
                    descent = options.fontSize * 0.2;
                lineHeight = (ascent + descent);
                options.height = lineHeight * options.childNodes.length;
            }
            let pivotX = options.x + options.width * options.pivotX;
            let pivotY = options.y + options.height * options.pivotY;
            this.rotateContext(canvas, options.angle, pivotX, pivotY);
            let i = 0;
            let childNodes = [];
            childNodes = options.childNodes;
            let wrapBounds = options.wrapBounds;
            ctx.fillStyle = options.color;
            if (wrapBounds) {
                let position = this.labelAlign(options, wrapBounds, childNodes, lineHeight);
                let padding = 0;
                let paddingY = 0;
                const heightDiff = rectHeight - (options.height + options.strokeWidth * 2);
                const stroke = Math.ceil(options.strokeWidth || 0);
                if (isFreeTextAnnotation && heightDiff >= 3.5) {
                    if (options.strokeWidth <= 4 && options.childNodes.length <= 1) {
                        padding = stroke * 1.5 * 1.65;
                        paddingY = stroke * 1.5 * 3;
                    }
                    else {
                        padding = stroke * 1.5 * 1.65;
                        if (options.strokeWidth <= 3) {
                            paddingY = stroke * 1.5 * 2;
                        }
                        else {
                            paddingY = stroke * 1.5 * 1.5;
                        }
                    }
                }
                else if (isFreeTextAnnotation) {
                    if (options.strokeWidth <= 4 && options.childNodes.length <= 1) {
                        padding = stroke * 1.5;
                        paddingY = stroke * 1.5;
                    }
                    else {
                        padding = stroke;
                        paddingY = stroke / 2;
                    }
                }
                else {
                    padding = options.strokeWidth / 2;
                    paddingY = options.strokeWidth / 2;
                }
                for (i = 0; i < childNodes.length; i++) {
                    let child = childNodes[parseInt(i.toString(), 10)];
                    let offsetX;
                    let offsetY;
                    let isTextDecorationApplied = false;
                    if (options.textAlign === 'justify') {
                        if (child.text === '\n')
                            continue;
                        let baseSpaceWidth = ctx.measureText(' ').width;
                        let targetWidth = this.rectWidth - (Math.ceil(options.strokeWidth) * 3 * 1.5);
                        offsetX = position.x + child.x - wrapBounds.x + padding;
                        offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8) + paddingY;
                        let isLastLine = i === childNodes.length - 1;
                        if (!isLastLine && targetWidth > 0) {
                            let leftEdge = position.x + child.x - wrapBounds.x + padding;
                            const words = child.text.trim().split(/\s+/);
                            if (words.length <= 1) {
                                ctx.fillText(child.text, leftEdge, offsetY);
                                continue;
                            }
                            const widths = words.map((w) => ctx.measureText(w).width);
                            const wordsTotal = widths.reduce((a, b) => a + b, 0);
                            const gaps = words.length - 1;
                            const naturalWidth = wordsTotal + baseSpaceWidth * gaps;
                            const extra = Math.max(0, targetWidth - naturalWidth);
                            const extraPerGap = extra / gaps;
                            let pen = leftEdge;
                            for (let i = 0; i < words.length; i++) {
                                ctx.fillText(words[i], pen, offsetY);
                                if (i < gaps) {
                                    pen += widths[i] + baseSpaceWidth + extraPerGap;
                                }
                            }
                            if (options.textDecoration === 'Underline'
                                || options.textDecoration === 'Overline'
                                || options.textDecoration === 'LineThrough') {
                                let startX = leftEdge;
                                let startY;
                                let endX = leftEdge + targetWidth;
                                let endY;
                                switch (options.textDecoration) {
                                    case 'Underline':
                                        startY = offsetY + 2;
                                        endY = offsetY + 2;
                                        break;
                                    case 'Overline':
                                        startY = (position.y + child.dy * i);
                                        endY = (position.y + child.dy * i);
                                        break;
                                    case 'LineThrough':
                                        startY = ((offsetY + position.y + child.dy * i) / 2) + 2;
                                        endY = ((offsetY + position.y + child.dy * i) / 2) + 2;
                                }
                                ctx.beginPath();
                                ctx.moveTo(startX, startY);
                                ctx.lineTo(endX, endY);
                                ctx.strokeStyle = options.color;
                                ctx.lineWidth = options.fontSize * .08;
                                ctx.globalAlpha = options.opacity;
                                ctx.stroke();
                                isTextDecorationApplied = true;
                            }
                        }
                        else {
                            ctx.fillText(child.text, offsetX, offsetY);
                        }
                    }
                    else if (child.text !== '\n') {
                        if (options.textAlign == "right") {
                            offsetX = position.x + child.x - wrapBounds.x - padding;
                        }
                        else if (options.textAlign == "center") {
                            offsetX = position.x + child.x - wrapBounds.x;
                        }
                        else {
                            offsetX = position.x + child.x - wrapBounds.x + padding;
                        }
                        if (options.relativeMode === 'Point') {
                            if (isFreeTextAnnotation && options.childNodes.length <= 1 && options.strokeWidth >= 5 && heightDiff <= 3.5) {
                                offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8) - paddingY;
                            }
                            else {
                                offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8) + paddingY;
                            }
                            if (options.strokeWidth == 0) {
                                offsetY += 1;
                            }
                        }
                        else {
                            offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8);
                        }
                        ctx.fillText(child.text, offsetX, offsetY);
                        // if (wrapBounds.width > options.width && options.textOverflow !== 'Wrap') {
                        //     child.text = overFlow(child.text, options);
                        // }
                        //ctx.fillText(child.text, offsetX, offsetY);
                    }
                    if (child.text !== '\n') {
                        let decorations = [];
                        if (Array.isArray(options.textDecoration)) {
                            decorations = options.textDecoration;
                        }
                        else if (options.textDecoration.includes(' ')) {
                            decorations = options.textDecoration.split(/[,\s]+/).filter(Boolean);
                        }
                        else {
                            decorations = [options.textDecoration];
                        }
                        for (let x = 0; x < decorations.length; x++) {
                            let textDecoration = decorations[x];
                            if (textDecoration === 'Underline'
                                || textDecoration === 'Overline'
                                || textDecoration === 'LineThrough' && !isTextDecorationApplied) {
                                let startPointX = offsetX;
                                let startPointY;
                                let textlength = ctx.measureText(child.text).width;
                                let endPointX = offsetX + textlength;
                                let endPointY;
                                switch (textDecoration) {
                                    case 'Underline':
                                        startPointY = offsetY + 2;
                                        endPointY = offsetY + 2;
                                        break;
                                    case 'Overline':
                                        startPointY = (position.y + child.dy * i);
                                        endPointY = (position.y + child.dy * i);
                                        break;
                                    case 'LineThrough':
                                        startPointY = ((offsetY + position.y + child.dy * i) / 2) + 2;
                                        endPointY = ((offsetY + position.y + child.dy * i) / 2) + 2;
                                }
                                ctx.beginPath();
                                ctx.moveTo(startPointX, startPointY);
                                ctx.lineTo(endPointX, endPointY);
                                ctx.strokeStyle = options.color;
                                ctx.lineWidth = options.fontSize * .08;
                                ctx.globalAlpha = options.opacity;
                                ctx.stroke();
                            }
                        }
                    }
                }
            }
            ctx.restore();
        }
    }
    /**   @private  */
    drawTextEJ2(canvas, options, isStampAnnotation) {
        if (options.content && options.visible === true) {
            let ctx = CanvasRenderer.getContext(canvas);
            ctx.save();
            this.setStyle(canvas, options);
            this.setFontStyle(canvas, options);
            let ascent = 0;
            let lineHeight = 0;
            if (options.thickness !== undefined) {
                // Used this to get the exact text height for Freetext annotation according to the font size and font family.
                const metrics = ctx.measureText(options.content);
                ascent = metrics.actualBoundingBoxAscent;
                if (ascent == null)
                    ascent = options.fontSize * 0.8;
                let descent = metrics.actualBoundingBoxDescent;
                if (descent == null)
                    descent = options.fontSize * 0.2;
                lineHeight = (ascent + descent);
                options.height = lineHeight * options.childNodes.length;
            }
            let pivotX = options.x + options.width * options.pivotX;
            let pivotY = options.y + options.height * options.pivotY;
            this.rotateContext(canvas, options.angle, pivotX, pivotY);
            let i = 0;
            let childNodes = [];
            childNodes = options.childNodes;
            let wrapBounds = options.wrapBounds;
            ctx.fillStyle = options.color;
            if (wrapBounds) {
                let position = this.labelAlign(options, wrapBounds, childNodes, lineHeight);
                let paddingAdjustment;
                if (isStampAnnotation) {
                    paddingAdjustment = options.thickness !== undefined ? (options.thickness * (96 / 72)) * 2 : 0;
                }
                for (i = 0; i < childNodes.length; i++) {
                    let child = childNodes[parseInt(i.toString(), 10)];
                    let offsetX;
                    let offsetY;
                    let isTextDecorationApplied = false;
                    if (options.textAlign === 'justify') {
                        if (child.text === '\n')
                            continue;
                        let baseSpaceWidth = ctx.measureText(' ').width;
                        let targetWidth = wrapBounds.width;
                        offsetX = position.x + child.x - wrapBounds.x + options.strokeWidth / 2;
                        offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8) + options.strokeWidth / 2;
                        let isLastLine = i === childNodes.length - 1;
                        if (!isLastLine && targetWidth > 0) {
                            let leftEdge = position.x + child.x + options.strokeWidth / 2;
                            const words = child.text.trim().split(/\s+/);
                            if (words.length <= 1) {
                                ctx.fillText(child.text, leftEdge, offsetY);
                                continue;
                            }
                            const widths = words.map((w) => ctx.measureText(w).width);
                            const wordsTotal = widths.reduce((a, b) => a + b, 0);
                            const gaps = words.length - 1;
                            const naturalWidth = wordsTotal + baseSpaceWidth * gaps;
                            const extra = Math.max(0, targetWidth - naturalWidth);
                            const extraPerGap = extra / gaps;
                            let pen = leftEdge;
                            for (let i = 0; i < words.length; i++) {
                                ctx.fillText(words[i], pen, offsetY);
                                if (i < gaps) {
                                    pen += widths[i] + baseSpaceWidth + extraPerGap;
                                }
                            }
                            if (options.textDecoration === 'Underline'
                                || options.textDecoration === 'Overline'
                                || options.textDecoration === 'LineThrough') {
                                let startX = leftEdge;
                                let startY;
                                let endX = leftEdge + targetWidth;
                                let endY;
                                switch (options.textDecoration) {
                                    case 'Underline':
                                        startY = offsetY + 2;
                                        endY = offsetY + 2;
                                        break;
                                    case 'Overline':
                                        startY = (position.y + child.dy * i);
                                        endY = (position.y + child.dy * i);
                                        break;
                                    case 'LineThrough':
                                        startY = ((offsetY + position.y + child.dy * i) / 2) + 2;
                                        endY = ((offsetY + position.y + child.dy * i) / 2) + 2;
                                }
                                ctx.beginPath();
                                ctx.moveTo(startX, startY);
                                ctx.lineTo(endX, endY);
                                ctx.strokeStyle = options.color;
                                ctx.lineWidth = options.fontSize * .08;
                                ctx.globalAlpha = options.opacity;
                                ctx.stroke();
                                isTextDecorationApplied = true;
                            }
                        }
                        else {
                            ctx.fillText(child.text, offsetX, offsetY);
                        }
                    }
                    else if (child.text !== '\n') {
                        if (options.textAlign == "right") {
                            offsetX = position.x + child.x - wrapBounds.x - options.strokeWidth / 2;
                        }
                        else if (options.textAlign == "center") {
                            offsetX = position.x + child.x - wrapBounds.x;
                        }
                        else {
                            if (isStampAnnotation) {
                                offsetX = position.x + child.x - wrapBounds.x + paddingAdjustment;
                            }
                            else {
                                offsetX = position.x + child.x - wrapBounds.x + options.strokeWidth / 2;
                            }
                        }
                        if (options.relativeMode === 'Point') {
                            if (isStampAnnotation) {
                                offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8) + paddingAdjustment;
                            }
                            else {
                                offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8) + options.strokeWidth / 2;
                            }
                        }
                        else {
                            offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8);
                        }
                        ctx.fillText(child.text, offsetX, offsetY);
                        // if (wrapBounds.width > options.width && options.textOverflow !== 'Wrap') {
                        //     child.text = overFlow(child.text, options);
                        // }
                        //ctx.fillText(child.text, offsetX, offsetY);
                    }
                    if (child.text !== '\n') {
                        if (options.textDecoration === 'Underline'
                            || options.textDecoration === 'Overline'
                            || options.textDecoration === 'LineThrough' && !isTextDecorationApplied) {
                            let startPointX = offsetX;
                            let startPointY;
                            let textlength = ctx.measureText(child.text).width;
                            let endPointX = offsetX + textlength;
                            let endPointY;
                            switch (options.textDecoration) {
                                case 'Underline':
                                    startPointY = offsetY + 2;
                                    endPointY = offsetY + 2;
                                    break;
                                case 'Overline':
                                    startPointY = (position.y + child.dy * i);
                                    endPointY = (position.y + child.dy * i);
                                    break;
                                case 'LineThrough':
                                    startPointY = ((offsetY + position.y + child.dy * i) / 2) + 2;
                                    endPointY = ((offsetY + position.y + child.dy * i) / 2) + 2;
                            }
                            ctx.beginPath();
                            ctx.moveTo(startPointX, startPointY);
                            ctx.lineTo(endPointX, endPointY);
                            ctx.strokeStyle = options.color;
                            ctx.lineWidth = options.fontSize * .08;
                            ctx.globalAlpha = options.opacity;
                            ctx.stroke();
                        }
                    }
                }
            }
            ctx.restore();
        }
    }
    /**@private*/
    drawFreeTextBlazor(canvas, options, maxHeight, isFreeTextAnnotation, zoomFactor) {
        if (options.content && options.visible === true) {
            let ctx = CanvasRenderer.getContext(canvas);
            ctx.save();
            this.setStyle(canvas, options);
            this.setFontStyle(canvas, options);
            let ascent = 0;
            let lineHeight = 0;
            if (options.thickness !== undefined) {
                // Used this to get the exact text height for Freetext annotation according to the font size and font family.
                const metrics = ctx.measureText(options.content);
                ascent = metrics.actualBoundingBoxAscent;
                if (ascent == null)
                    ascent = options.fontSize * 0.8;
                let descent = metrics.actualBoundingBoxDescent;
                if (descent == null)
                    descent = options.fontSize * 0.2;
                lineHeight = (ascent + descent);
                options.height = lineHeight * options.childNodes.length;
            }
            let pivotX = options.x + options.width * options.pivotX;
            let pivotY = options.y + options.height * options.pivotY;
            this.rotateContext(canvas, options.angle, pivotX, pivotY);
            let i = 0;
            let childNodes = [];
            childNodes = options.childNodes;
            let wrapBounds = options.wrapBounds;
            ctx.fillStyle = options.color;
            if (wrapBounds) {
                let position = this.labelAlign(options, wrapBounds, childNodes, lineHeight);
                let paddingAdjustmentX = options.thickness !== undefined && options.thickness === 0 ? Math.floor(options.thickness * (96 / 72)) + 2 : Math.floor(options.thickness * (96 / 72)) * 1 + 2;
                let paddingAdjustmentY = options.thickness !== undefined && options.thickness === 0 ? Math.floor(options.thickness * (96 / 72)) + 5 : Math.floor(options.thickness * (96 / 72)) * 1 + 4;
                let totalTextHeightCanvas = 0;
                for (let j = 0; j < childNodes.length; j++) {
                    let child = childNodes[j];
                    totalTextHeightCanvas += (child.dy ? child.dy : (lineHeight || options.fontSize * 1.2));
                }
                const isApplyClip = isFreeTextAnnotation && maxHeight > 0 && Math.ceil(totalTextHeightCanvas + paddingAdjustmentY + 4) > maxHeight;
                let clipLeft, clipTop, clipWidth, clipHeight;
                let clipActive = false;
                if (isApplyClip) {
                    if (options.textAlign == "right") {
                        clipLeft = position.x - paddingAdjustmentX;
                    }
                    else if (options.textAlign == "center") {
                        clipLeft = position.x;
                    }
                    else {
                        clipLeft = position.x + paddingAdjustmentX;
                    }
                    clipTop = position.y - ascent - paddingAdjustmentX;
                    clipWidth = Math.max(0, options.freeTextSelectorWidth + paddingAdjustmentX);
                    clipHeight = maxHeight + ascent;
                }
                if (isApplyClip) {
                    ctx.save();
                    ctx.beginPath();
                    ctx.rect(clipLeft, clipTop, clipWidth, clipHeight);
                    ctx.clip();
                    clipActive = true;
                }
                let textHeight = 0;
                for (i = 0; i < childNodes.length; i++) {
                    let child = childNodes[parseInt(i.toString(), 10)];
                    let offsetX;
                    let offsetY;
                    let isTextDecorationApplied = false;
                    if (options.textAlign === 'justify') {
                        if (child.text === '\n')
                            continue;
                        let baseSpaceWidth = ctx.measureText(' ').width;
                        let targetWidth = wrapBounds.width;
                        offsetX = position.x + child.x - wrapBounds.x + paddingAdjustmentX;
                        offsetY = position.y + child.dy * i + ascent + paddingAdjustmentY;
                        let isLastLine = i === childNodes.length - 1;
                        if (!isLastLine && targetWidth > 0) {
                            let leftEdge = position.x + child.x + paddingAdjustmentX;
                            const words = child.text.trim().split(/\s+/);
                            if (words.length <= 1) {
                                ctx.fillText(child.text, leftEdge, offsetY);
                                continue;
                            }
                            const widths = words.map((w) => ctx.measureText(w).width);
                            const wordsTotal = widths.reduce((a, b) => a + b, 0);
                            const gaps = words.length - 1;
                            const naturalWidth = wordsTotal + baseSpaceWidth * gaps + paddingAdjustmentX * 2;
                            const extra = Math.max(0, targetWidth - naturalWidth);
                            const extraPerGap = extra / gaps;
                            let pen = leftEdge;
                            for (let i = 0; i < words.length; i++) {
                                ctx.fillText(words[i], pen, offsetY);
                                if (i < gaps) {
                                    pen += widths[i] + baseSpaceWidth + extraPerGap;
                                }
                            }
                            if (options.textDecoration === 'Underline'
                                || options.textDecoration === 'Overline'
                                || options.textDecoration === 'LineThrough' || options.textDecoration === 'Underline LineThrough') {
                                let startX = leftEdge;
                                let startY;
                                let endX = leftEdge + targetWidth - paddingAdjustmentX * 2;
                                let endY;
                                switch (options.textDecoration) {
                                    case 'Underline':
                                        startY = offsetY + 2;
                                        endY = offsetY + 2;
                                        this.drawLine(ctx, startX, startY, endX, endY, options);
                                        break;
                                    case 'Overline':
                                        startY = (position.y + child.dy * i);
                                        endY = (position.y + child.dy * i);
                                        this.drawLine(ctx, startX, startY, endX, endY, options);
                                        break;
                                    case 'LineThrough':
                                        startY = ((offsetY + position.y + child.dy * i) / 2) + 2 + (paddingAdjustmentY / 2);
                                        endY = ((offsetY + position.y + child.dy * i) / 2) + 2 + (paddingAdjustmentY / 2);
                                        this.drawLine(ctx, startX, startY, endX, endY, options);
                                        break;
                                    case 'Underline LineThrough':
                                        this.drawLine(ctx, startX, offsetY + 2, endX, offsetY + 2, options);
                                        const midY = (offsetY + position.y + child.dy * i) / 2 + 2 + paddingAdjustmentY / 2;
                                        this.drawLine(ctx, startX, midY, endX, midY, options);
                                        break;
                                }
                                isTextDecorationApplied = true;
                            }
                        }
                        else {
                            ctx.fillText(child.text, offsetX, offsetY);
                        }
                    }
                    else if (child.text !== '\n') {
                        if (options.textAlign == "right") {
                            offsetX = position.x + child.x - wrapBounds.x - paddingAdjustmentX;
                        }
                        else if (options.textAlign == "center") {
                            offsetX = position.x + child.x - wrapBounds.x;
                        }
                        else {
                            offsetX = position.x + child.x - wrapBounds.x + paddingAdjustmentX;
                        }
                        if (options.relativeMode === 'Point') {
                            offsetY = position.y + child.dy * i + ascent + paddingAdjustmentY;
                        }
                        else {
                            offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8);
                        }
                        const tabSize = 7;
                        const textWithTabs = child.text.replace(/\t/g, ' '.repeat(tabSize));
                        textHeight += child.dy;
                        if (isFreeTextAnnotation || (maxHeight === 0 || (textHeight * zoomFactor < maxHeight * zoomFactor && isFreeTextAnnotation))) {
                            ctx.fillText(textWithTabs, offsetX, offsetY);
                        }
                        // if (wrapBounds.width > options.width && options.textOverflow !== 'Wrap') {
                        //     child.text = overFlow(child.text, options);
                        // }
                        //ctx.fillText(child.text, offsetX, offsetY);
                    }
                    else if (isFreeTextAnnotation) {
                        textHeight += child.dy;
                    }
                    if (child.text !== '\n') {
                        if (options.textDecoration === 'Underline'
                            || options.textDecoration === 'Overline'
                            || options.textDecoration === 'LineThrough'
                            || options.textDecoration === 'Underline LineThrough' && !isTextDecorationApplied) {
                            let startPointX = offsetX;
                            let startPointY;
                            let textlength = ctx.measureText(child.text).width;
                            let endPointX = offsetX + textlength;
                            let endPointY;
                            switch (options.textDecoration) {
                                case 'Underline':
                                    startPointY = offsetY + 2;
                                    endPointY = offsetY + 2;
                                    this.drawLine(ctx, startPointX, startPointY, endPointX, endPointY, options);
                                    break;
                                case 'Overline':
                                    startPointY = (position.y + child.dy * i);
                                    endPointY = (position.y + child.dy * i);
                                    this.drawLine(ctx, startPointX, startPointY, endPointX, endPointY, options);
                                    break;
                                case 'LineThrough':
                                    startPointY = ((offsetY + position.y + child.dy * i) / 2) + 2 + (paddingAdjustmentY / 2);
                                    endPointY = ((offsetY + position.y + child.dy * i) / 2) + 2 + (paddingAdjustmentY / 2);
                                    this.drawLine(ctx, startPointX, startPointY, endPointX, endPointY, options);
                                    break;
                                case 'Underline LineThrough':
                                    this.drawLine(ctx, startPointX, offsetY + 2, endPointX, offsetY + 2, options);
                                    const midY = (offsetY + position.y + child.dy * i) / 2 + 2 + paddingAdjustmentY / 2;
                                    this.drawLine(ctx, startPointX, midY, endPointX, midY, options);
                                    break;
                            }
                        }
                    }
                }
                if (clipActive) {
                    ctx.restore();
                }
            }
            ctx.restore();
        }
    }
    /**@private*/
    drawText(canvas, options, maxHeight, isFreeTextAnnotation, zoomFactor) {
        if (options.content && options.visible === true) {
            let ctx = CanvasRenderer.getContext(canvas);
            ctx.save();
            this.setStyle(canvas, options);
            this.setFontStyle(canvas, options);
            let ascent = 0;
            let lineHeight = 0;
            if (options.thickness !== undefined) {
                // Used this to get the exact text height for Freetext annotation according to the font size and font family.
                const metrics = ctx.measureText(options.content);
                ascent = metrics.actualBoundingBoxAscent;
                if (ascent == null)
                    ascent = options.fontSize * 0.8;
                let descent = metrics.actualBoundingBoxDescent;
                if (descent == null)
                    descent = options.fontSize * 0.2;
                lineHeight = (ascent + descent);
                options.height = lineHeight * options.childNodes.length;
            }
            let pivotX = options.x + options.width * options.pivotX;
            let pivotY = options.y + options.height * options.pivotY;
            this.rotateContext(canvas, options.angle, pivotX, pivotY);
            let i = 0;
            let childNodes = [];
            childNodes = options.childNodes;
            let wrapBounds = options.wrapBounds;
            ctx.fillStyle = options.color;
            if (wrapBounds) {
                let position = this.labelAlign(options, wrapBounds, childNodes, lineHeight);
                let paddingAdjustment = options.thickness !== undefined ? (options.thickness * (96 / 72)) * 2 : 0;
                let textHeight = 0;
                for (i = 0; i < childNodes.length; i++) {
                    let child = childNodes[parseInt(i.toString(), 10)];
                    let offsetX;
                    let offsetY;
                    let isTextDecorationApplied = false;
                    if (options.textAlign === 'justify') {
                        if (child.text === '\n')
                            continue;
                        let baseSpaceWidth = ctx.measureText(' ').width;
                        let targetWidth = wrapBounds.width;
                        offsetX = position.x + child.x - wrapBounds.x + paddingAdjustment;
                        offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8) + paddingAdjustment;
                        let isLastLine = i === childNodes.length - 1;
                        if (!isLastLine && targetWidth > 0) {
                            let leftEdge = position.x + child.x + paddingAdjustment;
                            const words = child.text.trim().split(/\s+/);
                            if (words.length <= 1) {
                                ctx.fillText(child.text, leftEdge, offsetY);
                                continue;
                            }
                            const widths = words.map((w) => ctx.measureText(w).width);
                            const wordsTotal = widths.reduce((a, b) => a + b, 0);
                            const gaps = words.length - 1;
                            const naturalWidth = wordsTotal + baseSpaceWidth * gaps + paddingAdjustment * 2;
                            const extra = Math.max(0, targetWidth - naturalWidth);
                            const extraPerGap = extra / gaps;
                            let pen = leftEdge;
                            for (let i = 0; i < words.length; i++) {
                                ctx.fillText(words[i], pen, offsetY);
                                if (i < gaps) {
                                    pen += widths[i] + baseSpaceWidth + extraPerGap;
                                }
                            }
                            if (options.textDecoration === 'Underline'
                                || options.textDecoration === 'Overline'
                                || options.textDecoration === 'LineThrough' || options.textDecoration === 'Underline LineThrough') {
                                let startX = leftEdge;
                                let startY;
                                let endX = leftEdge + targetWidth - paddingAdjustment * 2;
                                let endY;
                                switch (options.textDecoration) {
                                    case 'Underline':
                                        startY = offsetY + 2;
                                        endY = offsetY + 2;
                                        this.drawLine(ctx, startX, startY, endX, endY, options);
                                        break;
                                    case 'Overline':
                                        startY = (position.y + child.dy * i);
                                        endY = (position.y + child.dy * i);
                                        this.drawLine(ctx, startX, startY, endX, endY, options);
                                        break;
                                    case 'LineThrough':
                                        startY = ((offsetY + position.y + child.dy * i) / 2) + 2 + (paddingAdjustment / 2);
                                        endY = ((offsetY + position.y + child.dy * i) / 2) + 2 + (paddingAdjustment / 2);
                                        this.drawLine(ctx, startX, startY, endX, endY, options);
                                        break;
                                    case 'Underline LineThrough':
                                        this.drawLine(ctx, startX, offsetY + 2, endX, offsetY + 2, options);
                                        const midY = (offsetY + position.y + child.dy * i) / 2 + 2 + paddingAdjustment / 2;
                                        this.drawLine(ctx, startX, midY, endX, midY, options);
                                        break;
                                }
                                isTextDecorationApplied = true;
                            }
                        }
                        else {
                            ctx.fillText(child.text, offsetX, offsetY);
                        }
                    }
                    else if (child.text !== '\n') {
                        if (options.textAlign == "right") {
                            offsetX = position.x + child.x - wrapBounds.x - paddingAdjustment;
                        }
                        else if (options.textAlign == "center") {
                            offsetX = position.x + child.x - wrapBounds.x + (paddingAdjustment / 2);
                        }
                        else {
                            offsetX = position.x + child.x - wrapBounds.x + paddingAdjustment;
                        }
                        if (options.relativeMode === 'Point') {
                            offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8) + paddingAdjustment;
                        }
                        else {
                            offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8);
                        }
                        const tabSize = 7;
                        const textWithTabs = child.text.replace(/\t/g, ' '.repeat(tabSize));
                        textHeight += child.dy;
                        if (!isFreeTextAnnotation || (maxHeight === 0 || (textHeight * zoomFactor < maxHeight && isFreeTextAnnotation))) {
                            ctx.fillText(textWithTabs, offsetX, offsetY);
                        }
                        // if (wrapBounds.width > options.width && options.textOverflow !== 'Wrap') {
                        //     child.text = overFlow(child.text, options);
                        // }
                        //ctx.fillText(child.text, offsetX, offsetY);
                    }
                    else if (isFreeTextAnnotation) {
                        textHeight += child.dy;
                    }
                    if (child.text !== '\n') {
                        if (options.textDecoration === 'Underline'
                            || options.textDecoration === 'Overline'
                            || options.textDecoration === 'LineThrough'
                            || options.textDecoration === 'Underline LineThrough' && !isTextDecorationApplied) {
                            let startPointX = offsetX;
                            let startPointY;
                            let textlength = ctx.measureText(child.text).width;
                            let endPointX = offsetX + textlength;
                            let endPointY;
                            switch (options.textDecoration) {
                                case 'Underline':
                                    startPointY = offsetY + 2;
                                    endPointY = offsetY + 2;
                                    this.drawLine(ctx, startPointX, startPointY, endPointX, endPointY, options);
                                    break;
                                case 'Overline':
                                    startPointY = (position.y + child.dy * i);
                                    endPointY = (position.y + child.dy * i);
                                    this.drawLine(ctx, startPointX, startPointY, endPointX, endPointY, options);
                                    break;
                                case 'LineThrough':
                                    startPointY = ((offsetY + position.y + child.dy * i) / 2) + 2 + (paddingAdjustment / 2);
                                    endPointY = ((offsetY + position.y + child.dy * i) / 2) + 2 + (paddingAdjustment / 2);
                                    this.drawLine(ctx, startPointX, startPointY, endPointX, endPointY, options);
                                    break;
                                case 'Underline LineThrough':
                                    this.drawLine(ctx, startPointX, offsetY + 2, endPointX, offsetY + 2, options);
                                    const midY = (offsetY + position.y + child.dy * i) / 2 + 2 + paddingAdjustment / 2;
                                    this.drawLine(ctx, startPointX, midY, endPointX, midY, options);
                                    break;
                            }
                        }
                    }
                }
            }
            ctx.restore();
        }
    }
    /** @private  */
    drawTextBlazor(canvas, options, maxHeight, isFreeTextAnnotation, zoomFactor) {
        if (options.content && options.visible === true) {
            let ctx = CanvasRenderer.getContext(canvas);
            ctx.save();
            this.setStyle(canvas, options);
            this.setFontStyle(canvas, options);
            let ascent = 0;
            let lineHeight = 0;
            if (options.thickness !== undefined) {
                // Used this to get the exact text height for Freetext annotation according to the font size and font family.
                const metrics = ctx.measureText(options.content);
                ascent = metrics.actualBoundingBoxAscent;
                if (ascent == null)
                    ascent = options.fontSize * 0.8;
                let descent = metrics.actualBoundingBoxDescent;
                if (descent == null)
                    descent = options.fontSize * 0.2;
                lineHeight = (ascent + descent);
                options.height = lineHeight * options.childNodes.length;
            }
            let pivotX = options.x + options.width * options.pivotX;
            let pivotY = options.y + options.height * options.pivotY;
            this.rotateContext(canvas, options.angle, pivotX, pivotY);
            let i = 0;
            let childNodes = [];
            childNodes = options.childNodes;
            let wrapBounds = options.wrapBounds;
            ctx.fillStyle = options.color;
            if (wrapBounds) {
                let position = this.labelAlign(options, wrapBounds, childNodes, lineHeight);
                let paddingAdjustment = options.thickness !== undefined ? (options.thickness * (96 / 72)) * 2 : 0;
                let textHeight = 0;
                for (i = 0; i < childNodes.length; i++) {
                    let child = childNodes[parseInt(i.toString(), 10)];
                    let offsetX;
                    let offsetY;
                    let isTextDecorationApplied = false;
                    if (options.textAlign === 'justify') {
                        if (child.text === '\n')
                            continue;
                        let baseSpaceWidth = ctx.measureText(' ').width;
                        let targetWidth = wrapBounds.width;
                        offsetX = position.x + child.x - wrapBounds.x + paddingAdjustment;
                        offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8) + paddingAdjustment;
                        let isLastLine = i === childNodes.length - 1;
                        if (!isLastLine && targetWidth > 0) {
                            let leftEdge = position.x + child.x + paddingAdjustment;
                            const words = child.text.trim().split(/\s+/);
                            if (words.length <= 1) {
                                ctx.fillText(child.text, leftEdge, offsetY);
                                continue;
                            }
                            const widths = words.map((w) => ctx.measureText(w).width);
                            const wordsTotal = widths.reduce((a, b) => a + b, 0);
                            const gaps = words.length - 1;
                            const naturalWidth = wordsTotal + baseSpaceWidth * gaps + paddingAdjustment * 2;
                            const extra = Math.max(0, targetWidth - naturalWidth);
                            const extraPerGap = extra / gaps;
                            let pen = leftEdge;
                            for (let i = 0; i < words.length; i++) {
                                ctx.fillText(words[i], pen, offsetY);
                                if (i < gaps) {
                                    pen += widths[i] + baseSpaceWidth + extraPerGap;
                                }
                            }
                            if (options.textDecoration === 'Underline'
                                || options.textDecoration === 'Overline'
                                || options.textDecoration === 'LineThrough' || options.textDecoration === 'Underline LineThrough') {
                                let startX = leftEdge;
                                let startY;
                                let endX = leftEdge + targetWidth - paddingAdjustment * 2;
                                let endY;
                                switch (options.textDecoration) {
                                    case 'Underline':
                                        startY = offsetY + 2;
                                        endY = offsetY + 2;
                                        this.drawLine(ctx, startX, startY, endX, endY, options);
                                        break;
                                    case 'Overline':
                                        startY = (position.y + child.dy * i);
                                        endY = (position.y + child.dy * i);
                                        this.drawLine(ctx, startX, startY, endX, endY, options);
                                        break;
                                    case 'LineThrough':
                                        startY = ((offsetY + position.y + child.dy * i) / 2) + 2 + (paddingAdjustment / 2);
                                        endY = ((offsetY + position.y + child.dy * i) / 2) + 2 + (paddingAdjustment / 2);
                                        this.drawLine(ctx, startX, startY, endX, endY, options);
                                        break;
                                    case 'Underline LineThrough':
                                        this.drawLine(ctx, startX, offsetY + 2, endX, offsetY + 2, options);
                                        const midY = (offsetY + position.y + child.dy * i) / 2 + 2 + paddingAdjustment / 2;
                                        this.drawLine(ctx, startX, midY, endX, midY, options);
                                        break;
                                }
                                isTextDecorationApplied = true;
                            }
                        }
                        else {
                            ctx.fillText(child.text, offsetX, offsetY);
                        }
                    }
                    else if (child.text !== '\n') {
                        if (options.textAlign == "right") {
                            offsetX = position.x + child.x - wrapBounds.x - paddingAdjustment;
                        }
                        else if (options.textAlign == "center") {
                            offsetX = position.x + child.x - wrapBounds.x;
                        }
                        else {
                            offsetX = position.x + child.x - wrapBounds.x + paddingAdjustment;
                        }
                        if (options.relativeMode === 'Point') {
                            offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8) + paddingAdjustment;
                        }
                        else {
                            offsetY = position.y + child.dy * i + ((options.fontSize) * 0.8);
                        }
                        const tabSize = 7;
                        const textWithTabs = child.text.replace(/\t/g, ' '.repeat(tabSize));
                        textHeight += child.dy;
                        if (!isFreeTextAnnotation || (maxHeight === 0 || (textHeight * zoomFactor < maxHeight && isFreeTextAnnotation))) {
                            ctx.fillText(textWithTabs, offsetX, offsetY);
                        }
                        // if (wrapBounds.width > options.width && options.textOverflow !== 'Wrap') {
                        //     child.text = overFlow(child.text, options);
                        // }
                        //ctx.fillText(child.text, offsetX, offsetY);
                    }
                    else if (isFreeTextAnnotation) {
                        textHeight += child.dy;
                    }
                    if (child.text !== '\n') {
                        if (options.textDecoration === 'Underline'
                            || options.textDecoration === 'Overline'
                            || options.textDecoration === 'LineThrough'
                            || options.textDecoration === 'Underline LineThrough' && !isTextDecorationApplied) {
                            let startPointX = offsetX;
                            let startPointY;
                            let textlength = ctx.measureText(child.text).width;
                            let endPointX = offsetX + textlength;
                            let endPointY;
                            switch (options.textDecoration) {
                                case 'Underline':
                                    startPointY = offsetY + 2;
                                    endPointY = offsetY + 2;
                                    this.drawLine(ctx, startPointX, startPointY, endPointX, endPointY, options);
                                    break;
                                case 'Overline':
                                    startPointY = (position.y + child.dy * i);
                                    endPointY = (position.y + child.dy * i);
                                    this.drawLine(ctx, startPointX, startPointY, endPointX, endPointY, options);
                                    break;
                                case 'LineThrough':
                                    startPointY = ((offsetY + position.y + child.dy * i) / 2) + 2 + (paddingAdjustment / 2);
                                    endPointY = ((offsetY + position.y + child.dy * i) / 2) + 2 + (paddingAdjustment / 2);
                                    this.drawLine(ctx, startPointX, startPointY, endPointX, endPointY, options);
                                    break;
                                case 'Underline LineThrough':
                                    this.drawLine(ctx, startPointX, offsetY + 2, endPointX, offsetY + 2, options);
                                    const midY = (offsetY + position.y + child.dy * i) / 2 + 2 + paddingAdjustment / 2;
                                    this.drawLine(ctx, startPointX, midY, endPointX, midY, options);
                                    break;
                            }
                        }
                    }
                }
            }
            ctx.restore();
        }
    }
    //end region
    // Draw Line and Line Through
    drawLine(ctx, startPointX, startPointY, endPointX, endPointY, options) {
        ctx.beginPath();
        ctx.moveTo(startPointX, startPointY);
        ctx.lineTo(endPointX, endPointY);
        ctx.strokeStyle = options.color;
        ctx.lineWidth = options.fontSize * .08;
        ctx.globalAlpha = options.opacity;
        ctx.stroke();
    }
    // vector magnitude
    m(v) { return Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2)); }
    // ratio between two vectors
    r(u, v) { return (u[0] * v[0] + u[1] * v[1]) / (this.m(u) * this.m(v)); }
    // angle between two vectors
    a(u, v) { return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(this.r(u, v)); }
    getMeetOffset(arg, res, dest) {
        let max = Math.max(res, dest);
        let min = Math.min(res, dest);
        switch (arg) {
            case 'min': return 0;
            case 'mid': return (max - min) / 2;
            case 'max': return max - min;
            default: return 0;
        }
    }
    getSliceOffset(arg, res, dest, src) {
        switch (arg) {
            case 'min': return 0;
            case 'mid': return (res - dest) / 2 * src / res;
            case 'max': return (res - dest) * src / res;
            default: return 0;
        }
    }
    image(ctx, image, x, y, width, height, alignOptions, annotationCallback) {
        ctx.beginPath();
        let srcWidth = image.width;
        let srcHeight = image.height;
        let destinationW = width;
        let destinationH = height;
        let resultWidth = 0;
        let resultHeight = 0;
        ctx.globalAlpha = alignOptions.opacity;
        if (alignOptions && alignOptions.alignment !== 'None') {
            let xalign = alignOptions.alignment.toLowerCase().substr(1, 3);
            let yalign = alignOptions.alignment.toLowerCase().substr(5, 3);
            if (alignOptions.scale === 'Slice') {
                let a = () => {
                    resultWidth = destinationW;
                    resultHeight = srcHeight * destinationW / srcWidth;
                };
                let b = () => {
                    resultWidth = srcWidth * destinationH / srcHeight;
                    resultHeight = destinationH;
                };
                if (destinationW > destinationH) {
                    a();
                    if (destinationH > resultHeight) {
                        b();
                    }
                }
                else if (destinationW === destinationH) {
                    if (srcWidth > srcHeight) {
                        b();
                    }
                    else {
                        a();
                    }
                }
                else {
                    b();
                    if (destinationW > resultWidth) {
                        a();
                    }
                }
                let x1 = this.getSliceOffset(xalign, resultWidth, destinationW, srcWidth);
                let y1 = this.getSliceOffset(yalign, resultHeight, destinationH, srcHeight);
                let sWidth = srcWidth - x1;
                let sHeight = srcHeight - y1;
                let dWidth = resultWidth - (x1 * (resultWidth / srcWidth));
                let dHeight = resultHeight - (y1 * (resultHeight / srcHeight));
                let canvas1 = createHtmlElement('canvas', { 'width': width.toString(), 'height': height.toString() });
                let ctx1 = canvas1.getContext('2d');
                ctx.clearRect(x, y, dWidth, dHeight);
                ctx1.drawImage(image, x1, y1, sWidth, sHeight, 0, 0, dWidth, dHeight);
                ctx.clearRect(x, y, width, height);
                ctx.drawImage(canvas1, x, y, width, height);
            }
            else if (alignOptions.scale === 'Meet') {
                let srcRatio = (srcHeight / srcWidth);
                let destRatio = (destinationH / destinationW);
                resultWidth = destRatio > srcRatio ? destinationW : destinationH / srcRatio;
                resultHeight = destRatio > srcRatio ? destinationW * srcRatio : destinationH;
                x += this.getMeetOffset(xalign, resultWidth, destinationW);
                y += this.getMeetOffset(yalign, resultHeight, destinationH);
                ctx.clearRect(x, y, resultWidth, resultHeight);
                ctx.drawImage(image, 0, 0, srcWidth, srcHeight, x, y, resultWidth, resultHeight);
            }
            else {
                ctx.clearRect(x, y, width, height);
                ctx.drawImage(image, x, y, width, height);
            }
        }
        else {
            if (image.complete) {
                const canvasId = ctx.canvas.id;
                if (this.imageList[canvasId]) {
                    const existingImageIndex = this.isExistingImage(canvasId, this.imageList, alignOptions);
                    if (existingImageIndex !== -1) {
                        this.updateImageList(existingImageIndex, this.imageList, canvasId);
                    }
                    this.updateCanvasList(this.imageList, canvasId);
                }
                //ctx.clearRect(x, y, width, height);
                ctx.drawImage(image, x, y, width, height);
            }
            else {
                const proxy = this;
                let transform = ctx.getTransform();
                image.onload = null;
                const canvasId = ctx.canvas.id;
                if (!this.imageList[canvasId]) {
                    this.imageList[canvasId] = [];
                }
                const existingImageIndex = this.isExistingImage(canvasId, this.imageList, alignOptions);
                const newImageEntry = { id: alignOptions.id, image: image, canvasId: canvasId };
                if (existingImageIndex !== -1) {
                    this.updateImageList(existingImageIndex, this.imageList, canvasId);
                }
                this.imageList[canvasId].push(newImageEntry);
                image.onload = () => {
                    const lastIndex = alignOptions.id.lastIndexOf('_content');
                    const annotationID = lastIndex !== -1 ? alignOptions.id.substring(0, lastIndex) : alignOptions.id;
                    var annotationObject = true;
                    if (annotationCallback !== undefined && !annotationCallback(annotationID)) {
                        annotationObject = false;
                    }
                    if (annotationObject) {
                        ctx.setTransform(transform.a, transform.b, transform.c, transform.d, transform.e, transform.f);
                        //ctx.clearRect(x, y, width, height);
                        //ctx.drawImage(image, x, y, width, height);
                        const canvasIdValue = ctx.canvas.id;
                        if (proxy.imageList[canvasIdValue]) {
                            const existingImageIndex = proxy.isExistingImage(canvasIdValue, proxy.imageList, alignOptions);
                            if (existingImageIndex !== -1) {
                                proxy.updateImageList(existingImageIndex, proxy.imageList, canvasIdValue);
                                ctx.globalAlpha = alignOptions.opacity;
                                ctx.drawImage(image, x, y, width, height);
                            }
                            proxy.updateCanvasList(proxy.imageList, canvasIdValue);
                        }
                    }
                };
            }
        }
        ctx.closePath();
    }
    isExistingImage(canvasId, imageList, alignOptions) {
        return imageList[canvasId].findIndex(imageObject => imageObject.id === alignOptions.id);
    }
    updateImageList(existingImageIndex, imageList, canvasId) {
        imageList[canvasId][existingImageIndex].image.onload = null;
        imageList[canvasId].splice(existingImageIndex, 1);
    }
    updateCanvasList(imageList, canvasId) {
        if (imageList[canvasId] && imageList[canvasId].length === 0) {
            delete imageList[canvasId];
        }
    }
    // text utility
    loadImage(ctx, obj, canvas, pivotX, pivotY, annotationCallback, annotationType) {
        this.rotateContext(canvas, obj.angle, pivotX, pivotY);
        let image;
        if (window.customStampCollection && window.customStampCollection.get(obj.printID)) {
            image = window.customStampCollection.get(obj.printID);
        }
        else if (window.signatureCollection && window.signatureCollection.get(obj.printID)) {
            image = window.signatureCollection.get(obj.printID);
        }
        else {
            // Check if it is a sticky note type annotation
            if (window && window.stickyNote && window.stickyNote.src && annotationType && annotationType == 'StickyNotes') {
                image = window.stickyNote;
            }
            else {
                // Create a new Image and set the source
                image = new Image();
                image.src = obj.source;
            }
        }
        this.image(ctx, image, obj.x, obj.y, obj.width, obj.height, obj, annotationCallback);
    }
    /**   @private  */
    drawImage(canvas, obj, parentSvg, fromPalette, annotationCallback, annotationType) {
        if (obj.visible) {
            let ctx = CanvasRenderer.getContext(canvas);
            ctx.save();
            let pivotX = obj.x + obj.width * obj.pivotX;
            let pivotY = obj.y + obj.height * obj.pivotY;
            let imageObj = new Image();
            imageObj.src = obj.source;
            let id = ctx.canvas.id.split('_');
            let value = id[id.length - 1] === ('diagram' || 'diagramLayer') ? true : false;
            /**
             *  Since Clipping portion for node with slice option is not calculated properly
             * if (obj.sourceX !== undefined && obj.sourceY !== undefined && obj.sourceWidth !== undefined
             *  && obj.sourceHeight !== undefined) {
             *  ctx.drawImage(imageObj, obj.sourceX, obj.sourceY, obj.sourceWidth, obj.sourceHeight, obj.x, obj.y, obj.width, obj.height);
             *  } else {
             *             ctx.drawImage(imageObj, obj.x, obj.y, obj.width, obj.height);
             * }
             */
            if (!fromPalette) {
                this.loadImage(ctx, obj, canvas, pivotX, pivotY, annotationCallback, annotationType);
            }
            else {
                imageObj.onload = () => {
                    this.loadImage(ctx, obj, canvas, pivotX, pivotY);
                };
            }
            ctx.restore();
        }
    }
    /**   @private  */
    labelAlign(text, wrapBounds, childNodes, lineHeight) {
        let bounds = new Size(wrapBounds.width, childNodes.length * (text.fontSize * 1.2));
        const totalHeight = text.thickness !== undefined ? childNodes.length * lineHeight : 0;
        let position = { x: 0, y: 0 };
        let labelX = text.x;
        let labelY = text.y;
        let pointx = text.width * 0.5;
        let pointy = text.height * 0.5;
        if (text.isEJ2 === true) {
            if (text.textAlign === 'left' || text.textAlign === 'justify') {
                pointx = 0;
            }
            else if (text.textAlign === 'center') {
                if (wrapBounds.width > text.width && (text.textOverflow === 'Ellipsis' || text.textOverflow === 'Clip')) {
                    pointx = 0;
                }
                else {
                    pointx = text.width * 0.5;
                }
            }
            else if (text.textAlign === 'right') {
                pointx = (text.width * 1);
            }
        }
        else {
            if (text.textAlign === 'left') {
                pointx = 0;
            }
            else if (text.textAlign === 'center') {
                if (wrapBounds.width > text.width && (text.textOverflow === 'Ellipsis' || text.textOverflow === 'Clip')) {
                    pointx = 0;
                }
                else {
                    pointx = text.width * 0.5;
                }
            }
            else if (text.textAlign === 'right') {
                pointx = (text.width * 1);
            }
        }
        position.x = labelX + pointx + (wrapBounds ? wrapBounds.x : 0);
        if (text.thickness !== undefined) {
            position.y = labelY + (text.height * 0.5) - (totalHeight / 2);
        }
        else {
            position.y = labelY + pointy - bounds.height / 2;
        }
        return position;
    }
}
export function refreshDiagramElements(canvas, drawingObjects, renderer, annotationCallback, annotationType) {
    if (annotationType == "FreeText") {
        renderer.isFreeTextAnnotation = true;
    }
    if (annotationType == "Stamp") {
        renderer.isStampAnnotation = true;
    }
    for (let i = 0; i < drawingObjects.length; i++) {
        renderer.renderElement(drawingObjects[parseInt(i.toString(), 10)], canvas, undefined, undefined, undefined, undefined, undefined, undefined, annotationCallback, annotationType);
    }
    renderer.isFreeTextAnnotation = false;
    renderer.isStampAnnotation = false;
}
